import SARLogo from '../images/SARLogo.png';
import TeamRubicon from '../images/TeamRubicon.png';

const volunteerExperience = [
  {
    company: 'Cyber Security Club at NMU',
    position: 'Member',
    date: '2026 - Present',
    description: 
      'The Cyber Security Club at NMU is a student organization that focuses on promoting cybersecurity awareness, education, and skill development among students. Members participate in workshops, competitions, and collaborative projects to enhance their knowledge and practical skills in the field of cybersecurity.'
  },
  {
    // I have also started partnering with NMU faculty to make software and websites for departments on campus
    company: 'Northern Michigan University',
    position: 'Student Developer',
    date: '2026 - Present',
    description: 
      'I have partnered with NMU faculty to make software and websites for departments on campus. Currently collaborating with Dr. Kow to create a React based PWM website for the NMU Nursing department.'
  },
  {
    company: 'Superior Search and Rescue',
    position: 'Volunteer',
    date: '2025 - Present',
    logo: SARLogo,
    description:
      'Volunteer search and rescue operations providing emergency response services for missing persons and disaster relief in the Superior region.'
  },
  {
    company: 'Team Rubicon',
    position: 'Disaster Recovery Specialist',
    date: 'Aug 2020 - Present',
    logo: TeamRubicon,
    description:
      'Team Rubicon deploys on response, recovery, and mitigation operations to assist communities impacted by disaster.'
  },
  {
    company: 'Cultural Connect Program',
    position: 'Volunteer',
    date: 'Aug 2022 - Dec 2022',
    description:
      'The Cultural Connect program groups domestic college students with first-semester international college students.'
  }
];

export default volunteerExperience;
